import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const mdtCaseloadsApi = createApi({
  reducerPath: 'mdtCaseloadsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: "/mdt/caseload",
  }),
  tagTypes: ["MdtCaseloads", "MdtCaseloadDetails"],
  endpoints: (builder) => ({
    // get School clients list
    getMdtCaseloadList: builder.query({
      query: ({ search = "", status = "", page = 1, limit = 10, team_lead = "", sort = { column: "id", direction: "ASC" } }) => {
        return ({
          method: "PATCH",
          url: "/list",
          data: {
            search,
            team_lead,
            status,
            page,
            limit,
            sort,
          },
        })
      },
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["MdtCaseloads"]
    }),
    updateMdtAssessment: builder.mutation({
      query: ({ id, data }) => ({
        method: "PUT",
        url: `/update/${id}`,
        data
      }),
      invalidatesTags: ["MdtCaseloads"]
    }),
  }),
})

export const {
  useGetMdtCaseloadListQuery,
  useUpdateMdtAssessmentMutation
} = mdtCaseloadsApi;